import { FileEvent, ModernFile } from './documents.models';
import { NewDocumentRequest, ValueTupleOfBinaryAndString } from '../api';
import { RailProsError } from '../models/rail-pros-error.model';
import { bufferToBase64 } from '../utilities/utility-functions';
import * as moment from 'moment';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Dictionary } from '@ngrx/entity';

export function handleUpload(event: FileEvent): Observable<NewDocumentRequest> {
	if (!event || !event.target || !event.target.files) {
		throw new RailProsError(450, 'Error uploading file.');
	}
	if (event.target.files.length > 1) {
		throw new RailProsError(450, 'Only upload 1 file at a time.');
	}
	const fileObject = event.target.files[0] as ModernFile;
	const docRequest = from(fileObject.arrayBuffer()).pipe(
		map((file) => ({
			fileName: fileObject.name,
			timeStamp: moment.utc().toJSON(),
			attributes: [],
			data: bufferToBase64(new Uint8Array(file)),
		}))
	);

	return docRequest;
}

export function downloadDocument(response: ValueTupleOfBinaryAndString) {
	const bytes = base64ToArrayBuffer(response.item1.bytes);
	const blob = new Blob([bytes], {
		type: 'application/octet-stream',
	});
	const downloadUrl = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = downloadUrl;
	a.download = response.item2;
	document.body.appendChild(a);
	a.click();
}

export function previewDocument(response: ValueTupleOfBinaryAndString) {
	const bytes = base64ToArrayBuffer(response.item1.bytes);
	const ext = response.item2.split('.');
	const blob = new Blob([bytes], {
		type: fileExtensionToMimeType(ext[ext.length - 1]),
	});

	const fileUrl = URL.createObjectURL(blob);
	window.open(fileUrl, '_blank');
}

function base64ToArrayBuffer(base64: string): Uint8Array {
	const binaryString = window.atob(base64);
	const binaryLen = binaryString.length;
	const bytes = new Uint8Array(binaryLen);
	for (let i = 0; i < binaryLen; i++) {
		const ascii = binaryString.charCodeAt(i);
		bytes[i] = ascii;
	}
	return bytes;
}

function fileExtensionToMimeType(extension: string): string {
	const mimeTypes: Dictionary<string> = {
		img: 'image/jpeg',
		png: 'image/png',
		jpeg: 'image/jpeg',
		jpg: 'image/jpeg',
		bmp: 'image/bmp',
		pdf: 'application/pdf',
	};

	return mimeTypes[extension];
}
